const QUICK_LINKS = [
  { label: '精选推荐', href: '#cards' },
  { label: '电影专题', href: '#index' },
  { label: '热播榜单', href: '#ranking' },
  { label: '焦点专题', href: '#carousel' },
  { label: '最新动态', href: '#updates' },
  { label: '常见问题', href: '#faq' },
];

const PARTNER_LINKS = [
  { label: '合作伙伴一', href: '#contact' },
  { label: '合作伙伴二', href: '#contact' },
  { label: '合作伙伴三', href: '#contact' },
  { label: '合作伙伴四', href: '#contact' },
];

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="font-heading text-2xl font-bold text-primary-500">97</span>
              <span className="font-heading text-xl font-semibold text-foreground-900">影视</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              97影视汇聚海量电影资源，涵盖<strong>动作片</strong>、<strong>喜剧片</strong>等各类最新<strong>高清电影</strong>，全集免费在线观看，播放流畅不缓冲，给您极致观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {QUICK_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">合作伙伴</h4>
            <ul className="space-y-2">
              {PARTNER_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">联系方式</h4>
            <p className="text-sm text-foreground-500 mb-2">商务合作 / 内容投稿</p>
            <a
              href="#contact"
              onClick={(e) => handleClick(e, '#contact')}
              className="text-sm text-primary-500 hover:text-primary-400 transition-colors cursor-pointer"
            >
              点击联系我们 →
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 97影视 - 海量高清电影免费在线观看
          </p>
          <p className="text-xs text-foreground-400">
            本站内容仅供学习交流，请支持正版影视作品
          </p>
        </div>
      </div>
    </footer>
  );
}